import React, { Component } from "react";
import ToggleButton from "react-toggle-button";
import { toastr } from "react-redux-toastr";
import { update } from "../utils/apiService";
import { connect } from "react-redux";

// actions
import { updateVideo } from "../actions";

class VideoReadyToggle extends Component {
  constructor() {
    super();

    this.state = {
      ready: false
    };

    this.changeReadyState = this.changeReadyState.bind(this);
  }
  componentWillMount() {
    let { video } = this.props;
    this.setState({
      ready: video.ready
    });
  }
  changeReadyState(value) {
    toastr.info(`Atualizando ready para ${!value}`);
    let { video, updateVideo } = this.props;
    let url = `/campaigns/${video.campaign_id}/videos/${video.id}`;
    let data = {
      video: {
        ready: !value
      }
    };
    update(url, data)
      .then(res => {
        let updatedVideo = res.data;
        updateVideo(video.campaign_id, updatedVideo);
        toastr.success("Video atualizado com sucesso!");
        this.setState({ ready: !value });
      })
      .catch(err => {
        toastr.error("Erro ao atualizar video.");
      });
  }
  render() {
    return <ToggleButton value={this.state.ready} onToggle={value => this.changeReadyState(value)} />;
  }
}

const mapDispatchToProps = dispatch => ({
  updateVideo: (campaignId, video) => {
    dispatch(updateVideo(campaignId, video));
  }
});

export default connect(null, mapDispatchToProps)(VideoReadyToggle);



// WEBPACK FOOTER //
// ./src/components/VideoReadyToggle.js